<template>
	<div class="content">
		<div class="con_wrap">
			<div class="title">
				<i class="arrow" @click="back()"></i>
				<span>类目管理</span>
			</div>
		</div>
		<div class="inf_con_wrap">
			<el-table :data="dancelist" style="width: 100%"  :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                <el-table-column prop="name" align="center" label="名称"></el-table-column>
                <el-table-column prop="number" align="center" label="所含期数"></el-table-column>                        <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <span class="edit_info" @click="edit_dance(scope.$index)" style="margin-right:10px;"></span>
                        <span class="dele_info"  @click="dele_dance(scope.$index)"></span>
                    </template>
                </el-table-column>
            </el-table>
		</div>
		<div class="alertBox" v-if="show">
            <div class="alertMessage">
                <div class="alrt_title clearfix">
                    <div class="name fl_left">编辑舞种</div>
                    <div class="close fl_right" @click="qx_add_kj()"></div>
                </div>
                <div class="name_iptBox">
                    <label class="label_name">名称</label>
                    <input type="text" placeholder="名称" class="input_type" v-model="name">
                </div>
                <div class="name_iptBox clearfix" style="width:230px;">
                    <div class="fl_left alertBtn alertBd" @click="qd_editor()">确定</div>
                    <div class="fl_right alertBtn" @click="qx_add_kj()">取消</div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				dancelist:[],
				name:'',
				show:false,
				key:''
			}
		},
		methods:{
			back(){
				this.$router.go(-1);
			},
			qx_add_kj(){
				this.name = '';
				this.show = false;
			},
			edit_dance(i){
				this.show = true
				this.name = this.dancelist[i].name;
				this.key = i
			},
			qd_editor(){
				const _this=this;
				_this.$axios.post('editcourse',{course_id : _this.dancelist[_this.key].id,name : _this.name}).then( res =>{
					if(res.data.code == 200){
						_this.dancelist[_this.key].name = _this.name
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
			},
			dele_dance(i){
				const _this=this;
				_this.$confirm('此操作将永久删除该舞种, 是否继续?', '提示', {
		          	onfirmButtonText: '确定',
		          	cancelButtonText: '取消',
		         	type: 'warning'
		     	}).then(() => {
					_this.$axios.post('unhave',{ course_id:_this.dancelist[i].id }).then( res => {
						if(res.data.code == 200){
							_this.$message.success('删除成功!')
							_this.dancelist.splice(i,1)
							if(JSON.parse(sessionStorage.getItem('courseNum'))[1]  ==  _this.dancelist[i].id ){
								sessionStorage.removeItem('courseNum')
								// if(_this.dancelist.length > 0){
								// 	var arr=[_this.dancelist.length - 1,_this.dancelist[this.dancelist.length - 1].id]
								// 	sessionStorage.setItem('courseNum',JSON.stringify(arr))
								// }
							}
						}
						else{
							_this.$message.error(res.data.message)
						}
					}).catch( error =>{
						console.log(error)
					})
		        }).catch(() => {        
		        });
			},
			get_dance_list(){
				const _this=this;
				_this.$axios.post('getdancelist',{}).then( res => { 
					if(res.data.code == 200){
						_this.dancelist = res.data.data
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
			}
		},
		created(){
			const _this=this;
			_this.get_dance_list()
		}
	};
</script>
<style scoped>
	.content{width: 100%;min-height: 785px;width: 922px;margin: 20px auto 20px;background: #fff;}
	.con_wrap{padding-left: 24px;border-bottom: 1px solid #f5f5f5;}
	.title{line-height: 64px;font-size: 16px;font-weight: bold;box-sizing: border-box;}
	.inf_con_wrap{margin-top: 24px;padding: 0 22px 0 24px;box-sizing: border-box;}
	.arrow{width: 27px;height: 27px;display: inline-block;background: url(../../../static/imgs/back_purple.png) left center no-repeat;vertical-align: middle;margin-right: 10px;cursor: pointer;}
	.edit_info,.dele_info{background: url(../../../static/imgs/icon_write_gray.png) 0 center no-repeat;width: 16px;height:16px;display: inline-block;cursor: pointer;}
	.dele_info{background: url(../../../static/imgs/icon_delete_gray.png) 0 center no-repeat;margin-left: 5px;}
	.edit_info:hover{background: url(../../../static/imgs/icon_write_red.png) 0 center no-repeat;}
	.dele_info:hover{background: url(../../../static/imgs/icon_delete_red.png) 0 center no-repeat;} 

	.alertBox{position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 999;background: rgba(0,0,0,0.3);padding-top: 8%;}
.alertMessage{width: 500px;min-height: 300px;margin: 0 auto;background: #fff;border-radius: 4px;}
.alrt_title{background: #f4f5f9;padding: 0 10px;border-radius: 4px 4px 0 0 ;line-height: 43px;}
.close{background: url(../../../static/imgs/delect_qx.png) center center no-repeat;width: 20px;height: 44px;background-size: contain;cursor: pointer;}
.name_iptBox{border-radius: 4px;height: 38px;line-height: 38px;box-sizing: border-box;width: 320px;margin: 20px auto 0;}
.input_type{border:1px solid #e6e6e6;padding-left: 10px;background: #f5f5f5;width: 240px;height: 36px;border-radius: 4px; }
.label_name{margin-right: 20px;}
.alertBtn{width: 106px;height: 36px;box-sizing: border-box;text-align: center;line-height: 36px;border:1px solid #ddd;color:#333;border-radius: 4px;}
.alertBd{background: #595db5;color: #fff;border-color: #595db5;}

</style>


// WEBPACK FOOTER //
// src/components/index/CateManage.vue